/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Team_Settings_Data_ReadInputs */



/**
* | output |
* | --- |
* | "See timezone, bot language, data retention and recording exclusions" |
*
* @param {Perm_Team_Settings_Data_ReadInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_team_settings_data_read = /** @type {((inputs?: Perm_Team_Settings_Data_ReadInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Team_Settings_Data_ReadInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеть часовой пояс, язык бота, срок хранения данных и исключения из записи")
	return /** @type {LocalizedString} */ ("See timezone, bot language, data retention and recording exclusions")
});